import { zonedDayKey, addDaysToKey } from '../utils/kernelTimezone';
import React from 'react';
import { resolveLabel } from '../utils/fieldLabels';
import { NT_COLORS } from './NotionUI';
import { fmtDateDMY } from '../utils/format';

const BAR_WIDTHS = ['72%', '55%', '84%', '63%'];

function Pill({ text, color }) {
  return (
    <span className="tpl-pill" style={{ '--pill': NT_COLORS[color] || NT_COLORS.grey }}>
      {text}
    </span>
  );
}

function Bar({ width }) {
  return <span className="tpl-bar" style={{ width }} />;
}

/**
 * Mini-tabella di un modello: le prime colonne e le attività di esempio vere
 * del modello (titoli, pillole di stato, date...). Usa solo <span>: viene
 * renderizzata anche dentro un <button>.
 */
function TemplatePreview({ template, lang, large = false, hideTitle = false }) {
  const label = (labels) => resolveLabel(labels, lang, 'it-IT');
  const columns = template.columns.slice(0, large ? 5 : 3);
  const tasks = template.tasks.slice(0, large ? 3 : 2);

  const cell = (task, column, row, col) => {
    const raw = task.values[column.key];
    if (column.type === 'title') return <span className="tpl-text">{label(task.title)}</span>;
    if (raw === undefined) return <Bar width={BAR_WIDTHS[(row + col) % BAR_WIDTHS.length]} />;
    if (column.type === 'select' || column.type === 'status') {
      const option = column.options.find((o) => o.value === raw);
      return option ? <Pill text={label(option.label)} color={option.color} /> : null;
    }
    if (column.type === 'date') {
      return <span className="tpl-text">{fmtDateDMY(addDaysToKey(zonedDayKey(new Date()), Number(raw)))}</span>;
    }
    if (column.type === 'text') return <span className="tpl-text">{typeof raw === 'object' ? label(raw) : raw}</span>;
    return <span className="tpl-text">{String(raw)}</span>;
  };

  return (
    <span className="tpl-preview">
      {!hideTitle && (
        <span className="tpl-preview-title">
          <span aria-hidden="true">{template.icon}</span> {label(template.name)}
        </span>
      )}
      <span className="tpl-table" style={{ '--cols': columns.length }}>
        <span className="tpl-row tpl-row-head">
          {columns.map((column) => (
            <span key={column.key}>{label(column.name)}</span>
          ))}
        </span>
        {tasks.map((task, row) => (
          <span key={row} className="tpl-row">
            {columns.map((column, col) => (
              <span key={column.key}>{cell(task, column, row, col)}</span>
            ))}
          </span>
        ))}
      </span>
    </span>
  );
}

export default TemplatePreview;
